import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {

  return {
	  current_user: state.users.current,
	  loading: state.page.loading,
	  errors: state.page.errors
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
	  getCurrentUser: () => dispatch(stdAction(ACTIONS.users.current)),
	  signInUser: (values) => dispatch(stdAction(ACTIONS.users.signin, values)),
	  signOutUser: () => dispatch(stdAction(ACTIONS.users.signout))
  }
}

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(View)

export default Container
